import React from "react";
import { Engineeringstudy, OtherCategory } from "./Results/Index.js";

export default function ResultsEdit({ apiData, params, closeModal, category }) {
  const categoryType = {
    engineeringstudy: Engineeringstudy,
    casing: OtherCategory,
    equipments: OtherCategory,
    renewables: OtherCategory,
    contracts: OtherCategory,
    usage: OtherCategory,
    behaviour: OtherCategory,
  };

  const SelectedCategoryType = categoryType[category];

  return (
    <SelectedCategoryType
      apiData={apiData}
      params={params}
      closeModal={closeModal}
    />
  );
}
